/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_DropInputs */



/**
* | output |
* | --- |
* | "Drop" |
*
* @param {Players_DropInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_drop = /** @type {((inputs?: Players_DropInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_DropInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retirar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desistir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandona")
	return /** @type {LocalizedString} */ ("Drop")
});